import React from 'react';

type Props = {
  width: number;
  height: number;
  fill?: string;
}

const SystemDataIcon = ({
  width, height, fill,
}: Props) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill={fill} d="M0 14.6667V13.1852H16V14.6667H0ZM2.18182 12.4445C1.78182 12.4445 1.43939 12.2994 1.15455 12.0093C0.869697 11.7191 0.727273 11.3704 0.727273 10.963V2.81482C0.727273 2.40742 0.869697 2.05865 1.15455 1.76853C1.43939 1.47841 1.78182 1.33334 2.18182 1.33334H13.8182C14.2182 1.33334 14.5606 1.47841 14.8455 1.76853C15.1303 2.05865 15.2727 2.40742 15.2727 2.81482V10.963C15.2727 11.3704 15.1303 11.7191 14.8455 12.0093C14.5606 12.2994 14.2182 12.4445 13.8182 12.4445H2.18182ZM2.18182 10.963H13.8182V2.81482H2.18182V10.963Z" />
  </svg>
);

SystemDataIcon.defaultProps = {
  fill: 'var(--systemDataColor)',
};

export default SystemDataIcon;
